import React, {createRef, useState} from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import {
  Wrap,
  Hero,
  FirstSection,
  SecondSection,
  Block,
  Materiali,
  Istituto,
  Card,
  ScrollContainer,
  PallinoWrap,
  Shadow,
} from "./styles";
import {
  MainTitle,
  FirstTitle,
  Termometer,
  House,
  Megafono,
  Book,
  Penna,
  Grafiche,
  SecondTitle,
  Eta,
  Agenti,
  NuvolaDue,
  NuvolaUno,
  ScrollBar,
  Pallino,
} from "./Icons";

export default function Landing(props) {
  const ScrollBarWithRef = React.forwardRef((props, ref) => (
    <div ref={ref}>
      <ScrollBar />
    </div>
  ));
  const scrollRef = createRef(null);
  const [isPopUpOpen, setPopUpOpen] = useState(false);

  return (
    <Wrap>
      <Hero id="header">
        <div>
          <Header
            history={props.history}
            screen="landing"
            firstButton={{action: () => props.history.push("/project?register"), label: "REGISTRATI"}}
            secondButton={{action: () => props.history.push("/project?login"), label: "ACCEDI"}}
          />
        </div>
        <div>
          <MainTitle />
          <div>
            <button onClick={() => setPopUpOpen(!isPopUpOpen)}>LEGGI LA LETTERA</button>
            <button onClick={() => props.history.push("/project")}>ACCEDI AI MATERIALI</button>
          </div>
        </div>
        {isPopUpOpen && (
          <Shadow onClick={() => setPopUpOpen(!isPopUpOpen)}>
            <div>
              <span onClick={() => setPopUpOpen(!isPopUpOpen)}>CHIUDI</span>
              <article>
                Caro insegnante, <br />
                <br />
                questo kit didattico è stato pensato per accompagnare te e i tuoi studenti in una missione
                importantissima: affrontare i cambiamenti climatici una scuola alla volta, partendo dalla tua classe!
                Per realizzare questo piano ambizioso, vi aiuteremo ad addestrare dei veri{" "}
                <label>“Agenti 0 emissioni”</label>, pronti a cambiare le proprie abitudini all’insegna della
                sostenibilità nella vita quotidiana e a far sentire la propria voce in modo che i cambiamenti climatici
                diventino un tema all’ordine del giorno sulle scrivanie di chi prende decisioni importanti per il futuro
                di tutti noi. <br />
                <br />
                Prima di passare all’azione, gli Agenti devono acquisire informazioni, competenze e anche un po’ di
                coraggio. Come sai, infatti, la consapevolezza e la spinta ad agire non possono nascere se non ci sono
                conoscenza e comprensione dei fenomeni. Questo kit ti aiuterà a far crescere una squadra di “Agenti 0
                emissioni” nutrendoli con sapere, speranza e motivazione per affrontare la sfida più grande del nostro
                tempo: la crisi climatica.
                <br />
                <br />
                Il kit che stai per scoprire è stato quindi pensato per accompagnare i tuoi studenti in questo percorso,
                attraverso tre passi fondamentali: <br />
                <br />
                1. <label>Imparare.</label> La scienza dei cambiamenti climatici. <br />
                2. <label>Capire.</label> Vivere in un Pianeta più caldo. <br />
                3. <label>Agire.</label> Strumenti e pratiche per passare all’azione. <br />
                <br />
                Questi tre passi o macro aree, in cui è suddiviso il kit, includono argomenti che variano dall’ambito
                scientifico a quello socio-economico, al fine di comprendere meglio tutti gli effetti dei cambiamenti
                climatici. All’interno di ciascuna area <label>troverai lezioni “pronte all’uso”</label>, da utilizzare
                in classe o da consegnare per lo studio a casa, <label>quiz finali e attività ludico-didattiche</label>{" "}
                da fare con gli studenti. <label>Le lezioni sono declinate su due target d’età:</label> per la scuola
                primaria (9-11 anni) e per la scuola secondaria di primo grado (12-14 anni). I contenuti sono in linea
                con il nucleo tematico dello sviluppo sostenibile dell’insegnamento trasversale dell’educazione civica.
                Le prime due sezioni (Imparare e Capire) hanno lo scopo di preparare gli “Agenti” alla vera missione di
                cambiamento, realizzabile grazie ai materiali della terza sezione (Agire), dove con attività pratiche
                potrete lavorare su due obiettivi: ridurre l’impronta carbonica della scuola e contribuire alla
                comunicazione della crisi climatica. Ogni sezione si conclude con un attestato che riconosce l’impegno
                della classe e il risultato ottenuto.
                <br />
                <br />
                Di seguito l’elenco dei contenuti del kit didattico, divisi per sezione. <br />
                <br />
                <label>1.Imparare:</label>
                <ul>
                  <li>Video lezione introduttiva, che sintetizza i principali contenuti tematici della sezione</li>
                  <li>
                    Lezione 1.1 - I cambiamenti climatici nella storia della Terra - Formato: presentazione interattiva
                    da usare in classe
                  </li>
                  <li>
                    Lezione 1.2 - Come si studiano i cambiamenti climatici - Formato: scheda da stampare e distribuire +
                    scheda con attività didattica da svolgere in classe
                  </li>
                  <li>
                    Lezione 1.3 - Cambiamenti climatici e biodiversità - Formato: scheda da stampare e distribuire +
                    scheda per docenti con attività didattica
                  </li>
                  <li>
                    Lezione 1.4 - Tra mitigazione e adattamento: le risposte ai cambiamenti climatici - Formato:
                    presentazione interattiva da usare in classe
                  </li>
                  <li>Quiz su tutti gli argomenti trattati nelle lezioni</li>
                  <li>Infografiche da stampare e appendere in classe</li>
                  <li>Attestato finale per la classe</li>
                </ul>{" "}
                <br />
                <br />
                <label>2. Capire:</label>
                <ul>
                  <li>Video lezione introduttiva, che sintetizza i principali contenuti tematici della sezione</li>
                  <li>Lezione 2.1 - Ingiustizie climatiche - Formato: presentazione interattiva da usare in classe</li>
                  <li>
                    Lezione 2.2 - Guerre climatiche e migrazioni ambientali - Formato: presentazione interattiva da
                    usare in classe
                  </li>
                  <li>
                    Lezione 2.3 - I diritti dei bambini e la crisi climatica - Formato: scheda da stampare e distribuire
                    + scheda per docenti con attività didattica da svolgere in classe
                  </li>
                  <li>Quiz su tutti gli argomenti trattati nelle lezioni</li>
                  <li>Infografiche da stampare e appendere in classe</li>
                  <li>Attestato finale per la classe</li>
                </ul>{" "}
                <br />
                <br />
                <label>3. Agire:</label>
                <ul>
                  <li>
                    Lezione 3.1 - Missione: riduzione. Arma segreta: risparmio energetico - Formato: presentazione
                    interattiva + scheda per docenti con proposta di attivazione
                  </li>
                  <li>
                    Lezione 3.2 - Missione: riduzione. Arma segreta: mobilità sostenibile - Formato: presentazione
                    interattiva + scheda per docenti con proposta di attivazione
                  </li>
                  <li>
                    Lezione 3.3 - Missione: fai sentire la tua voce. Arma segreta: parlare in pubblico - Formato: scheda
                    ad uso dei docenti
                  </li>
                  <li>
                    Lezione 3.4 - Missione: fai sentire la tua voce. Arma segreta: advocacy - Formato: presentazione
                    interattiva + proposta di attivazione
                  </li>
                  <li>
                    Lezione 3.5 - Missione: fai sentire la tua voce. Arma segreta: il dibattito - Formato: scheda ad uso
                    dei docenti
                  </li>
                  <li>Attestato personale finale</li>
                </ul>{" "}
                <br />
                <br />
                All’interno del kit troverai inoltre una sezione di approfondimento: una selezione di link a video,
                articoli, siti web, libri e film. <br />
                <br />
                <br />
                Questo kit servirà non solo ad aumentare la conoscenza e la consapevolezza degli studenti, ma
                soprattutto ad aiutarli a comprendere meglio cosa possono fare per concretizzare un vero cambiamento.
                Mentre noi fatichiamo ad adattarci ai cambiamenti climatici, la Terra lo fa da milioni di anni. Anche
                l'economia e la società possono cambiare e i ragazzi hanno bisogno di mettere a fuoco il loro ruolo da
                protagonisti all’interno di questo complesso sistema.
                <br />
                <br />
                <label>
                  La sfida ai cambiamenti climatici ci pone di fronte al vero significato dell’essere cittadini del
                  mondo!
                </label>
                <br />
                <br />
                Buona missione!
                <br />
                <br />
                <span>Il team di Istituto Oikos</span>
                <br /> <br />
                <span>
                  I contenuti di questo kit sono stati realizzati dal personale di Istituto Oikos, con la supervisione
                  scientifica di Stefano Caserini, ingegnere ambientale e professore di Mitigazione dei Cambiamenti
                  Climatici presso il Politecnico di Milano e Gianluca Ruggieri, ingegnere ambientale e ricercatore
                  presso il Dipartimento di Scienze Teoriche e Applicate dell’Università degli Studi dell’Insubria.
                </span>
              </article>
            </div>
          </Shadow>
        )}
      </Hero>
      <FirstSection>
        <div>
          <FirstTitle />
          <p>
            Il clima del nostro Pianeta sta cambiando molto in fretta, con conseguenze drammatiche per tutti:
            acidificazione degli oceani, scioglimento dei ghiacci, innalzamento delle temperature, desertificazione,
            perdita di biodiversità. La sopravvivenza e la salute di molte specie, tra cui l’uomo, sono in pericolo.
            <br />
            <br />
            L’educazione e la mobilitazione dei giovani sono essenziali per contrastare la crisi climatica.{" "}
            <span>Scuole, insegnanti ed educatori sono in prima linea</span> in una sfida che non possiamo perdere.
          </p>
        </div>
        <div></div>
      </FirstSection>
      <SecondSection>
        <div></div>
        <div>
          <SecondTitle />
          <p>
            Questo <label>percorso didattico</label> può aiutarti a parlare di cambiamenti climatici in classe e ad
            attivare i tuoi studenti. La missione: cambiare il futuro, una classe per volta. Grazie a materiali pronti
            per l’uso, potrai trasformare la tua classe in una squadra di{" "} <span className="no_svg">Agenti 0 Emissioni</span>
            <span>
              <Agenti />
            </span>
            : agenti speciali, pronti ad agire per un futuro più sostenibile, consapevoli dell’impatto straordinario che
            possono avere sul Pianeta.
            <br />
            <br />
            Come? Aumentando le loro conoscenze e competenze sui cambiamenti climatici e fornendogli strumenti per
            affermare il proprio ruolo nella società. I materiali sono pensati per bambini e ragazzi{" "} <span className="no_svg">dai 9 ai 14 anni</span>
            <span>
              <Eta />
            </span>
          </p>
        </div>
      </SecondSection>
      <PallinoWrap>
        <Pallino />
      </PallinoWrap>
      <ScrollContainer>
        <ScrollBarWithRef ref={scrollRef} />
        <Block>
          <div>
            <div>
              <h3>IMPARARE</h3>
              <h4>La scienza dei cambiamenti climatici</h4>
              <p>
                Il primo passo per diventare “Agenti 0 emissioni” è sapere cosa dice la scienza: perché il clima cambia?
                Perchè bisogna preoccuparsene? Cosa possiamo fare? I cambiamenti climatici non avranno più segreti.
              </p>
              <button onClick={() => props.history.push("/project")}>ACCEDI AI MATERIALI</button>
            </div>
          </div>
          <div>
            <Termometer />
          </div>
        </Block>
        <Block>
          <NuvolaUno />
          <div>
            <House />
          </div>
          <div>
            <div>
              <h3>CAPIRE</h3>
              <h4>Vivere in un Pianeta più caldo</h4>
              <p>
                Gli “Agenti 0 emissioni” vanno oltre l'osservazione dei fenomeni naturali in atto: il secondo passo è
                capire come i cambiamenti climatici influenzano le comunità umane, nella propria città e nel mondo.
                Perché un Pianeta più caldo è anche più ingiusto?
              </p>
              <button onClick={() => props.history.push("/project")}>ACCEDI AI MATERIALI</button>
            </div>
          </div>
        </Block>
        <Block>
          <div>
            <div>
              <h3>AGIRE</h3>
              <h4>Strumenti e pratiche per passare all'azione</h4>
              <p>
                Gli “Agenti 0 emissioni” sono quasi pronti ad agire. L’ultimo passo è dotarsi dell'attrezzatura
                necessaria: competenze per far sentire la propria voce e strategie per iniziare subito a ridurre il
                proprio impatto sul Pianeta.
              </p>
              <button onClick={() => props.history.push("/project")}>ACCEDI AI MATERIALI</button>
            </div>
          </div>
          <div>
            <Megafono />
          </div>
        </Block>
      </ScrollContainer>
      <Materiali>
        <NuvolaDue />
        <h2>I MATERIALI DIDATTICI IN BREVE</h2>
        <div>
          <Card>
            <Book />
            <span>+12</span>
            <span>
              LEZIONI <br /> PRONTE ALL'USO
            </span>
          </Card>
          <Card>
            <Penna />
            <span>+7</span>
            <span>
              QUIZ PER GLI <br /> AGENTI 0 EMISSIONI
            </span>
          </Card>
          <Card>
            <Grafiche />
            <span>+4</span>
            <span>
              INFOGRAFICHE DA <br /> APPENDERE IN CLASSE
            </span>
          </Card>
        </div>
      </Materiali>
      <Istituto>
        <div>
          <h2>
            ISTITUTO OIKOS E SAVE THE CHILDREN <br /> ALLEATI PER IL CLIMA
          </h2>
          <p>
            Il kit didattico “Agenti 0 emissioni” è realizzato da{" "}
            <a href=" https://www.istituto-oikos.org/it" target="_blank" rel="noopener noreferrer">
              Istituto Oikos
            </a>{" "}
            nell’ambito del progetto{" "}
            <a
              href="https://www.istituto-oikos.org/progetti/children-stand-up"
              target="_blank"
              rel="noopener noreferrer"
            >
              Children Stand Up
            </a>{" "}
            promosso in collaborazione con Save the Children Italia e Save the Children Albania, grazie al sostegno
            dell’European Climate Initiative (
            <a href="https://www.euki.de/en/" target="_blank" rel="noopener noreferrer">
              EUKI
            </a>
            ) del Ministero federale tedesco per l'ambiente, la conservazione della natura e la sicurezza nucleare
            (BMU).
            <br />
            <br />
            Istituto Oikos è un’organizzazione non-profit impegnata dal 1996 in Italia e nel mondo nella tutela della
            biodiversità, per una gestione responsabile delle risorse naturali e per la diffusione di modelli di vita
            più sostenibili.
          </p>
        </div>
        <div></div>
      </Istituto>
      {!isPopUpOpen && <span
        onClick={() => {
          document.getElementById("header").scrollIntoView();
        }}
      >
        <svg width="78" height="78" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
          <defs>
            <path id="j" d="M0 0h46v26H0z" />
          </defs>
          <g fill="none" fillRule="evenodd">
            <circle fill="#F5A462" fillRule="nonzero" cx="39" cy="39" r="39" />
            <g transform="rotate(-180 31 26)">
              <mask id="x" fill="#fff">
                <use xlinkHref="#j" />
              </mask>
              <path
                d="M22.999924 26c-.824414 0-1.648726-.312123-2.277267-.935055L.943652 5.452706C-.31455 4.205125-.31455 2.182385.943652.935308 2.201346-.31177 4.2409-.31177 5.499204.935308L22.999924 18.2893 40.500744.935913c1.258306-1.247077 3.297553-1.247077 4.555146 0 1.258814 1.247077 1.258814 3.269817 0 4.517399L25.27719 25.06555c-.628846.623034-1.453158.93445-2.277266.93445"
                fill="#FFF"
                mask="url(#x)"
              />
            </g>
          </g>
        </svg>
      </span>}
      <Footer />
    </Wrap>
  );
}
